import axios from "axios";
import { useEffect, useState, useRef } from "react";
import Header from "../../components/Header";
import { io } from "socket.io-client";

import "../XDia/xd.css";
import "./tx.css"; 

import bgFrame from "../../../statics/md5/ccccccc.png"; 
import imgChen from "../../../statics/md5/toMD5.png"; 
import bgMain from "../../../statics/md5/background-3.png"; 
import frameNoti from "../../../statics/txmd5/Frame_Notification_1.png"; 
import btnNanDisable from "../../../statics/md5/nan.png"; 
import btnNanEnable from "../../../statics/txmd5/nanDisableBlack.png"; 
import txtTai from "../../../statics/txmd5/tai.png";
import txtXiu from "../../../statics/txmd5/xiu.png";
import btnAllIn from "../../../statics/txmd5/allIn.png"; 
import btnDatCuoc from "../../../statics/txmd5/datCuoc.png"; 
import btnHuy from "../../../statics/txmd5/huy.png"; 
import btnCuocSmall from "../../../statics/txmd5/tXU.png"; 
import xx1 from "../../../statics/txmd5/xx1_1.png";
import xx2 from "../../../statics/txmd5/xx2_1.png";
import xx3 from "../../../statics/txmd5/xx3_1.png";
import xx4 from "../../../statics/txmd5/xx4_1.png";
import xx5 from "../../../statics/txmd5/xx5_1.png";
import xx6 from "../../../statics/txmd5/xx6_1.png";
import dotTai from "../../../statics/txmd5/taiden.png";
import dotXiu from "../../../statics/txmd5/xiutrang.png"; 
import chip1k from "../../../statics/txmd5/1K.png";
import chip10k from "../../../statics/txmd5/10K.png";
import chip50k from "../../../statics/txmd5/50K.png";
import chip100k from "../../../statics/txmd5/100K.png";
import chip500k from "../../../statics/txmd5/500K.png";
import chip1m from "../../../statics/txmd5/1M.png";
import chip10m from "../../../statics/txmd5/10M.png";
import chip20m from "../../../statics/txmd5/20M.png"; 
import bgChat from "../../../statics/md5/boxchat.png";
import btnChatGui from "../../../statics/txmd5/buttonGui.png";
import iconChatToggle from "../../../statics/md5/chat.png"; 
import btnCloseChat from "../../../statics/md5/ic_close.png"; 
import iconHelp from "../../../statics/md5/dauhoi.png"; 
import imgGuide from "../../../statics/txmd5/gioithieumd5.png"; 
import iconHistory from "../../../statics/md5/lsc.png"; 
import bgHistory from "../../../statics/txmd5/boder.png"; 
import icoPageBack from "../../../statics/txmd5/icoBack.png"; 
import icoNext from "../../../statics/txmd5/icoNext.png"; 
import bgDetail from "../../../statics/txmd5/board_history.png"; 
import bgSoiCau from "../../../statics/txmd5/Panel_ThongKe_2.png"; 
import iconStat from "../../../statics/md5/invalidName.png"; 
import btnBackMain from "../../../statics/txmd5/icoBack.png"; 
import imgAvatar from "../../../statics/txmd5/19.png";           
import iconMoney from "../../../statics/txmd5/ic_tien.png";     
import imgPlusMoney from "../../../statics/txmd5/icPlus02.png"; 

import winSoundFile from "../../../statics/audio/Winer.mp3"; 
import clickSoundFile from "../../../statics/audio/click.mp3"; 

const diceMap = { 1: xx1, 2: xx2, 3: xx3, 4: xx4, 5: xx5, 6: xx6 };
const chipMap = {
    '1000': chip1k, '10000': chip10k, '50000': chip50k, '100000': chip100k,
    '500000': chip500k, '1000000': chip1m, '10000000': chip10m, '20000000': chip20m,
};
const formatMoney = (n) => String(n ? n : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

const assetsToPreload = [
    bgFrame, imgChen, bgMain, frameNoti, btnNanDisable, btnNanEnable,
    txtTai, txtXiu, btnAllIn, btnDatCuoc, btnHuy, btnCuocSmall,
    dotTai, dotXiu, bgChat, btnChatGui, iconChatToggle, btnCloseChat,
    iconHelp, imgGuide, iconHistory, bgHistory, icoPageBack, icoNext,
    bgDetail, bgSoiCau, iconStat, btnBackMain, imgAvatar, iconMoney,
    imgPlusMoney,
    ...Object.values(diceMap),
    ...Object.values(chipMap)
];

function TXMD560s() {
    const [isLoading, setIsLoading] = useState(true);
    const [progress, setProgress] = useState(0);

    const [bet, setBet] = useState(null);
    const [profile, setProfile] = useState(null);
    const [historyGame, setHistoryGame] = useState(null);
    const [isShuffle, setIsShuffle] = useState(false);
    const [second, setSecond] = useState(0); 
    const [rawSecond, setRawSecond] = useState(75); 
    const [start, setStart] = useState(false); 
    const [setting, setSetting] = useState(null); 

    const [total, setTotal] = useState([]); 
    const [newMoney, setNewMoney] = useState("");
    const [choose, setChoose] = useState([]); 
    const [activeOption, setActiveOption] = useState(null);
    const [myBetTai, setMyBetTai] = useState(0);
    const [myBetXiu, setMyBetXiu] = useState(0);
    const [showChat, setShowChat] = useState(true); 
    const [messages, setMessages] = useState([]);
    const [msgInput, setMsgInput] = useState("");
    
    const [isBowlOpen, setIsBowlOpen] = useState(false); 
    const [isShaking, setIsShaking] = useState(false);
    const [isDropping, setIsDropping] = useState(false);
    const [isNan, setIsNan] = useState(false); 
    
    const [isUserDraggingBowl, setIsUserDraggingBowl] = useState(false);

    const [bowlOffset, setBowlOffset] = useState({ x: 0, y: 0 }); 
    const isDraggingBowl = useRef(false);
    const dragStartPos = useRef({ x: 0, y: 0 });
    
    const [notiText, setNotiText] = useState("");
    const [notiColor, setNotiColor] = useState("gold"); 
    const [showNoti, setShowNoti] = useState(false);
    const [showWin, setShowWin] = useState(false);
    const [winAmount, setWinAmount] = useState(0);
    const [winSide, setWinSide] = useState(null); 
    const [showGuide, setShowGuide] = useState(false);
    const [showHistory, setShowHistory] = useState(false); 
    const [showDetail, setShowDetail] = useState(false);
    const [showSoiCau, setShowSoiCau] = useState(false);
    const [hoverDot, setHoverDot] = useState(null); 
    const [currentPage, setCurrentPage] = useState(1); 
    const itemsPerPage = 10; 
    const [activeBounce, setActiveBounce] = useState(null);

    const socketRef = useRef();
    const chatBoxRef = useRef();
    const boardRef = useRef(null);
    const chatRef = useRef(null);
    const dragRef = useRef({ isDraggingGame: false, isDraggingChat: false, startX: 0, startY: 0, initialObjX: 0, initialObjY: 0 });
    const posRef = useRef({ game: { x: 0, y: 0 }, chat: { x: 0, y: 0 } });
    const userBetRef = useRef({ id_bet: null, side: null, money: 0 });
    
    const audioRef = useRef(new Audio(winSoundFile));
    const clickAudioRef = useRef(new Audio(clickSoundFile));

    useEffect(() => {
        clickAudioRef.current.volume = 0.8;
        clickAudioRef.current.load();

        let loadedCount = 0;
        const totalAssets = assetsToPreload.length;

        const handleImageLoad = () => {
            loadedCount++;
            const percent = Math.floor((loadedCount / totalAssets) * 100);
            setProgress(percent);

            if (loadedCount >= totalAssets) {
                setTimeout(() => {
                    setIsLoading(false);
                }, 500);
            }
        };

        if (totalAssets === 0) {
            setIsLoading(false);
        } else {
            assetsToPreload.forEach((src) => {
                const img = new Image();
                img.src = src;
                img.onload = handleImageLoad;
                img.onerror = handleImageLoad; 
            });
        }
    }, []);

    const playClick = () => {
        try {
            if (clickAudioRef.current) {
                clickAudioRef.current.currentTime = 0; 
                clickAudioRef.current.play().catch(() => {});
            }
        } catch (e) {}
    };
    
    const triggerNoti = (text, color, duration = 2500) => {
        setNotiText(text); setNotiColor(color); setShowNoti(true);
        setTimeout(() => setShowNoti(false), duration);
    };

    const handleCellClick = (index) => {
        playClick(); 
        setActiveBounce(index); 
        setTimeout(() => setActiveBounce(null), 500);
    };

    axios.interceptors.request.use(config => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    }, error => Promise.reject(error));

    useEffect(() => {
        const requestFullScreen = () => {
            const el = document.documentElement;
            const rfs = el.requestFullscreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen;
            if(rfs) {
                rfs.call(el).catch((err) => {
                    console.log("Fullscreen error or denied:", err);
                });
            }
        };

        const handleInteraction = () => {
            if (window.innerWidth <= 900) {
                if (!document.fullscreenElement && !document.webkitFullscreenElement) {
                    requestFullScreen();
                }
            }
        };

        window.addEventListener('touchstart', handleInteraction, { once: true });
        window.addEventListener('click', handleInteraction, { once: true });

        return () => {
            window.removeEventListener('touchstart', handleInteraction);
            window.removeEventListener('click', handleInteraction);
        };
    }, []);

    useEffect(() => {
        if (rawSecond > 20) {
            if (isBowlOpen) setIsBowlOpen(false); 
            if (showWin) setShowWin(false);
            if (winSide) setWinSide(null);
            
            if (bowlOffset.x !== 0 || bowlOffset.y !== 0) setBowlOffset({ x: 0, y: 0 });
            if (isDraggingBowl.current) isDraggingBowl.current = false;
            if (isUserDraggingBowl) setIsUserDraggingBowl(false);
        }

        if (rawSecond <= 15) {
            if (rawSecond <= 0) {
                 if (!isBowlOpen) setIsBowlOpen(true);
            }
            else {
                if (!isNan) {
                    if (!isBowlOpen) setIsBowlOpen(true);
                }
            }
        }
    }, [rawSecond, isNan, isBowlOpen, isUserDraggingBowl]);

    useEffect(() => {
        getProfile();
        fetchHistory();
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`).then((res) => { if(res.data.success) setSetting(res.data.data[0]); });

        socketRef.current = io(process.env.REACT_APP_API_URL || "http://localhost:5000"); 

        socketRef.current.on("tx_time", (data) => {
            const serverTime = data.time !== undefined ? data.time : data; 
            if (data.data) setBet(prev => ({ ...prev, ...data.data }));
            setRawSecond(serverTime);
            setStart(true);

            if (serverTime > 15) {
                setSecond(serverTime - 15);
            } else {
                setSecond(serverTime);
            }

            if (serverTime === 74) triggerNoti("BẮT ĐẦU CƯỢC", "gold", 1500);
            if (serverTime === 25) triggerNoti("SẮP HẾT GIỜ", "gold", 2000); 
            if (serverTime === 20) triggerNoti("ĐÃ ĐÓNG CƯỢC", "red", 2000); 
            if (serverTime === 15) {
                triggerNoti("ĐÃ ĐÓNG CƯỢC", "red", 1000);
                setTimeout(() => triggerNoti("TRẢ KẾT QUẢ", "green", 2000), 500);
            }
        });

        socketRef.current.on("tx_update_data", (data) => {
            setBet(prev => ({ ...prev, ...data }));
        });

        socketRef.current.on("tx_result", (data) => {
            const newResult = { id_bet: data.id_bet, result: data.result, ...data };
            setTotal(prev => {
                if (prev.length > 0 && prev[0].id_bet === newResult.id_bet) return prev;
                return [newResult, ...prev];
            });
            setTimeout(() => { getProfile(); fetchHistory(); }, 1000);
        });

        socketRef.current.on("tx_new_session", (newSessionData) => {
            setBet(newSessionData);
            setStart(true);
            
            setIsBowlOpen(true); 
            setBowlOffset({ x: 0, y: 0 });
            isDraggingBowl.current = false;
            setIsUserDraggingBowl(false);
            
            setWinSide(null);
            setShowWin(false);
            setMyBetTai(0); 
            setMyBetXiu(0);
            setNewMoney(""); 
            setActiveOption(null); 

            setIsShuffle(true); 
            setIsDropping(false); 
            setIsShaking(false);

            setTimeout(() => {
                setIsShuffle(false);     

                setTimeout(() => {
                    setIsBowlOpen(false); 
                    
                    setTimeout(() => {
                        setIsShaking(true);
                        setTimeout(() => setIsShaking(false), 800); 
                    }, 600); 
                    
                }, 100); 
            }, 1500); 

            triggerNoti("PHIÊN MỚI", "green");
        });
        
        socketRef.current.on("tx_init_session", (data) => {
            if (data.session) setBet(data.session);
            setRawSecond(data.time);
            setStart(true);
            
            setIsDropping(false);

            if (data.time <= 15) {
                setSecond(data.time);
                setIsBowlOpen(true);
            } else {
                setSecond(data.time - 15);
                setIsBowlOpen(false);
            }
        });

        socketRef.current.on("load_messages", (msgs) => { setMessages(msgs); scrollToBottom(); });
        socketRef.current.on("new_message", (msg) => { setMessages((prev) => [...prev, msg]); scrollToBottom(); });

        return () => { if(socketRef.current) socketRef.current.disconnect(); };
    }, []); 

    const updateMyBet = (currentIdBet, historyData) => {
        if (!currentIdBet || !historyData) return;
        let tai = 0; let xiu = 0;
        const myBets = historyData.filter(item => String(item.id_bet) === String(currentIdBet) && item.sanh === "TXMD560s");
        myBets.forEach(item => {
            if (item.state === "3") tai += item.money;
            if (item.state === "4") xiu += item.money;
        });
        setMyBetTai(tai); setMyBetXiu(xiu);
    };

    function getProfile() { axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser?t=${new Date().getTime()}`).then((res) => { if(res.data.success) setProfile(res.data.data); }); }
    
    const fetchHistory = () => { 
        axios.get(`${process.env.REACT_APP_API_URL}/taixiumd560s/getallbet?t=${new Date().getTime()}`).then((res) => { 
            if(res.data.success) { setTotal(res.data.data.filter(i => i.result)); } 
        }).catch(() => setTotal([])); 
        axios.get(`${process.env.REACT_APP_API_URL}/history/historyus?t=${new Date().getTime()}`, { params: { keyword: "TXMD560s" } }).then((res) => { 
            if(res.data.success) {
                setHistoryGame(res.data.data);
                if (bet && bet.id_bet) { updateMyBet(bet.id_bet, res.data.data); }
            } 
        }).catch(() => {}); 
    };
    
    useEffect(() => { 
        if (bet && bet.id_bet) { 
            fetchHistory(); 
        } 
    }, [bet?.id_bet]);

    useEffect(() => {
        if (!isBowlOpen) {
            setWinSide(null);
            setShowWin(false);
            return;
        }
        if (isBowlOpen && total.length > 0 && total[0].result) {
            const dice = total[0].result.split(" ").map(Number);
            const sum = dice.reduce((a, b) => a + b, 0);
            const resultSide = sum > 10 ? "TAI" : "XIU"; 
            setWinSide(resultSide); 
            const blinkTimeout = setTimeout(() => { setWinSide(null); }, 5000); 

            if (userBetRef.current.id_bet === total[0].id_bet && userBetRef.current.money > 0) {
                const userChoice = userBetRef.current.side === "3" ? "TAI" : "XIU";
                if (userChoice === resultSide) {
                    const profit = userBetRef.current.money * 0.98;
                    setWinAmount(profit);
                    setShowWin(true);
                    try { audioRef.current.currentTime = 0; audioRef.current.play().catch(() => {}); } catch (e) {}
                    setTimeout(() => { setShowWin(false); setWinAmount(0); }, 3000);
                }
                userBetRef.current = { id_bet: null, side: null, money: 0 };
            }
            return () => clearTimeout(blinkTimeout);
        }
    }, [total, isBowlOpen]); 

    const getClientPos = (e) => {
        if (e.touches && e.touches.length > 0) return { x: e.touches[0].clientX, y: e.touches[0].clientY };
        return { x: e.clientX, y: e.clientY };
    };

    const startSqueeze = (e) => {
        if (!isNan || isBowlOpen || rawSecond > 15) return;
        e.stopPropagation(); 
        isDraggingBowl.current = true;
        setIsUserDraggingBowl(true); 
        const { x, y } = getClientPos(e);
        dragStartPos.current = { x, y };
    };

    const startDrag = (e, type) => {
        if (e.type === 'mousedown' && e.button !== 0) return;
        if (isDraggingBowl.current) return;
        const { x, y } = getClientPos(e);
        dragRef.current.startX = x; dragRef.current.startY = y;
        if (type === 'game') {
            dragRef.current.isDraggingGame = true;
            dragRef.current.initialObjX = posRef.current.game.x;
            dragRef.current.initialObjY = posRef.current.game.y;
        } else if (type === 'chat') {
            dragRef.current.isDraggingChat = true;
            dragRef.current.initialObjX = posRef.current.chat.x;
            dragRef.current.initialObjY = posRef.current.chat.y;
        }
    };

    const moveDrag = (e) => {
        if (isDraggingBowl.current) {
            e.preventDefault(); 
            const { x, y } = getClientPos(e);
            let dx = x - dragStartPos.current.x;
            let dy = y - dragStartPos.current.y;
            if (window.innerWidth <= 900) { const temp = dx; dx = dy; dy = -temp; }
            setBowlOffset({ x: dx, y: dy });
            return;
        }
        if (!dragRef.current.isDraggingGame && !dragRef.current.isDraggingChat) return;
        const { x, y } = getClientPos(e);
        let dx = x - dragRef.current.startX; let dy = y - dragRef.current.startY;
        if (window.innerWidth <= 900) { const tempDx = dx; dx = dy; dy = -tempDx; }

        if (dragRef.current.isDraggingGame && boardRef.current) {
            const newX = dragRef.current.initialObjX + dx; const newY = dragRef.current.initialObjY + dy;
            posRef.current.game = { x: newX, y: newY }; boardRef.current.style.transform = `translate(${newX}px, ${newY}px)`;
        }
        if (dragRef.current.isDraggingChat && chatRef.current) {
            const newX = dragRef.current.initialObjX + dx; const newY = dragRef.current.initialObjY + dy;
            posRef.current.chat = { x: newX, y: newY }; chatRef.current.style.transform = `translate(${newX}px, ${newY}px)`;
        }
    };

    const endDrag = () => { 
        dragRef.current.isDraggingGame = false; 
        dragRef.current.isDraggingChat = false; 
        if (isDraggingBowl.current) {
            isDraggingBowl.current = false;
            setIsUserDraggingBowl(false); 
            if (Math.abs(bowlOffset.x) > 60 || Math.abs(bowlOffset.y) > 60) {
                setIsBowlOpen(true);
                setBowlOffset({ x: 0, y: 0 });
            } else {
                setBowlOffset({ x: 0, y: 0 });
            }
        }
    };

    const scrollToBottom = () => { if (chatBoxRef.current) setTimeout(() => { chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight; }, 100); };
    const sendMessage = (e) => {
        e.preventDefault(); 
        if (!msgInput.trim()) return; 
        if (!profile) return triggerNoti("VUI LÒNG ĐĂNG NHẬP", "red");
        socketRef.current.emit("send_message", { userId: profile._id, username: profile.username, content: msgInput });
        setMsgInput("");
    };

    const handleOptionClick = (option) => { 
        playClick(); 
        setActiveOption(option); 
        const currentMoney = newMoney ? Number(newMoney.replaceAll(".", "")) : 0;
        const total = currentMoney + Number(option);
        setNewMoney(formatMoney(total)); 
    };

    function onChoose(num) { 
        playClick(); 
        if (num === "3") { setChoose(["3"]); } else if (num === "4") { setChoose(["4"]); } 
    }
    const handleHuy = (e) => { 
        playClick(); 
        e.stopPropagation(); setNewMoney(""); setChoose([]); setActiveOption(null); 
    }
    const onSubmit = (e) => {
        playClick(); 
        e.preventDefault(); e.stopPropagation(); 
        if (!bet || !bet.id_bet) return triggerNoti("ĐANG TẢI PHIÊN...", "red");
        if (rawSecond <= 20) return triggerNoti("ĐÃ ĐÓNG CƯỢC", "red");
        if (rawSecond > 75) return triggerNoti("CHƯA MỞ CƯỢC", "red");
        if (!newMoney || newMoney === "0") { triggerNoti("VUI LÒNG NHẬP TIỀN", "red"); return; }
        if (choose.length === 0) return triggerNoti("VUI LÒNG CHỌN CỬA", "red");
        
        if (choose[0] === "3" && myBetXiu > 0) {
            return triggerNoti("BẠN ĐÃ CƯỢC XỈU!", "red");
        }
        if (choose[0] === "4" && myBetTai > 0) {
            return triggerNoti("BẠN ĐÃ CƯỢC TÀI!", "red");
        }

        const rawMoney = Number(newMoney.replaceAll(".", ""));
        if (profile && profile.money < rawMoney) { triggerNoti("SỐ DƯ KHÔNG ĐỦ", "red"); return; }
        
        axios.post(`${process.env.REACT_APP_API_URL}/history/chooseTXMD560s`, { result: choose[0], id_bet: bet.id_bet, money: rawMoney })
            .then((res) => {
                if(res.data.success) { 
                    userBetRef.current = { id_bet: bet.id_bet, side: choose[0], money: rawMoney };
                    triggerNoti("ĐẶT CƯỢC THÀNH CÔNG", "gold", 1500);
                    setNewMoney(""); setActiveOption(null); getProfile(); fetchHistory(); 
                } 
                else { triggerNoti(res.data.message || "THẤT BẠI", "red"); }
            }).catch((err) => { triggerNoti("KHÔNG THỂ CƯỢC", "red"); });
    };
    const copyText = (text) => { if(text) { navigator.clipboard.writeText(text); triggerNoti("ĐÃ COPY MD5", "gold"); } };

    let sumDice = 0;
    if (total.length > 0 && total[0].result) { 
        sumDice = total[0].result.split(" ").reduce((a,b)=>Number(a)+Number(b),0); 
    }

    const filteredHistory = historyGame ? historyGame.filter(item => item.sanh === "TXMD560s").sort((a, b) => b.id_bet - a.id_bet) : [];
    const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);
    const currentHistoryData = filteredHistory.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const handleNextPage = () => { playClick(); if (currentPage < totalPages) setCurrentPage(currentPage + 1); };
    const handlePrevPage = () => { playClick(); if (currentPage > 1) setCurrentPage(currentPage - 1); };
    const displayCode = isBowlOpen ? (total.length > 0 ? total[0].hash || total[0].hash_result || "RESULT_HASH..." : "...") : (bet?.md5 || "...");

    if (isLoading) {
        return (
            <div className="preload-container">
                <div className="loader-box">
                    <div className="loader-logo">ĐANG TẢI...</div>
                    <div className="loader-bar-bg">
                        <div className="loader-bar-fill" style={{ width: `${progress}%` }}></div>
                    </div>
                    <div className="loader-text">{progress}%</div>
                </div>
                <style>{`
                   .preload-container {
    width: 100vw; height: 100vh;
    background: #000 url(${bgMain}) center/cover no-repeat;
    display: flex; justify-content: center; align-items: center;
    position: fixed; top: 0; left: 0; 
    z-index: 999999; /* Tăng lên 999999 */
}
                    .loader-box { text-align: center; width: 60%; max-width: 400px; }
                    .loader-logo { 
                        color: #ffd700; font-family: 'Russo One', sans-serif; 
                        font-size: 24px; margin-bottom: 20px; text-transform: uppercase;
                        text-shadow: 0 0 10px #ff0000;
                    }
                    .loader-bar-bg {
                        width: 100%; height: 20px;
                        background: #1a1a1a; border: 2px solid #ffd700;
                        border-radius: 10px; overflow: hidden;
                        box-shadow: 0 0 15px rgba(0,0,0,0.8);
                    }
                    .loader-bar-fill {
                        height: 100%; background: linear-gradient(90deg, #ff8c00, #ffd700);
                        transition: width 0.1s linear;
                    }
                    .loader-text {
                        color: #fff; margin-top: 10px; font-weight: bold; font-family: monospace;
                    }
                `}</style>
            </div>
        );
    }

    return (
        <div className="tx-md5-container" onMouseMove={moveDrag} onMouseUp={endDrag} onTouchMove={moveDrag} onTouchEnd={endDrag}>
            <div className="hud-back-btn btn-effect" onClick={() => window.history.back()}><img src={btnBackMain} alt="Back" /></div>

            <div className="hud-user-info">
                <div className="hud-avatar-frame"><img src={imgAvatar} alt="Avatar" /></div>
                <div className="hud-text-info">
                    <div className="hud-username">{profile?.username || "Guest"}</div>
                    <div className="hud-money"><img src={iconMoney} alt="$" /><span>{profile?.money ? Math.floor(profile.money).toLocaleString("vi-VN") : "0"}</span></div>
                </div>
            </div>

            <div className="pc-header"><Header profile={profile} /></div>
            
            <div ref={boardRef} className="draggable-board" style={{ transform: `translate(0px, 0px)` }} onMouseDown={(e) => startDrag(e, 'game')} onTouchStart={(e) => startDrag(e, 'game')}>
                <div className="board-scaler">
                    <img src={bgFrame} alt="BanChoi" className="bg-frame-img" draggable="false" />
                    {showWin && <div className="win-effect-container"><img src={imgPlusMoney} className="win-icon" alt="" /><div className="win-amount">{formatMoney(winAmount)}</div></div>}
                    {showNoti && <div className="custom-noti-box"><img src={frameNoti} className="noti-bg" alt="noti-bg" /><div className={`noti-text-content ${notiColor}`}>{notiText}</div></div>}

                    <div className="obj-chat-toggle btn-effect" onMouseDown={e=>e.stopPropagation()} onTouchStart={e=>e.stopPropagation()} onClick={() => { playClick(); setShowChat(true); }}><img src={iconChatToggle} alt="Chat" draggable="false" /></div>
                    <div className="obj-help-toggle btn-effect" onMouseDown={e=>e.stopPropagation()} onTouchStart={e=>e.stopPropagation()} onClick={() => { playClick(); setShowGuide(true); }}><img src={iconHelp} alt="Help" draggable="false" /></div>
                    <div className="obj-history-toggle btn-effect" onMouseDown={e=>e.stopPropagation()} onTouchStart={e=>e.stopPropagation()} onClick={() => { playClick(); setShowHistory(true); setCurrentPage(1); }}><img src={iconHistory} alt="History" draggable="false" /></div>
                    <div className="obj-stat-toggle btn-effect" onMouseDown={e=>e.stopPropagation()} onTouchStart={e=>e.stopPropagation()} onClick={() => { playClick(); setShowSoiCau(true); }}><img src={iconStat} alt="SoiCau" draggable="false" /></div>
                    
                    <div className="obj-nan-toggle btn-effect" onMouseDown={e=>e.stopPropagation()} onTouchStart={e=>e.stopPropagation()} onClick={() => { playClick(); setIsNan(!isNan); }}>
                        <img src={isNan ? btnNanEnable : btnNanDisable} alt="Nan" draggable="false" />
                    </div>

                    <div className="obj-phien">#{bet?.id_bet || "..."}</div>
                    <div className="obj-md5" onMouseDown={e=>e.stopPropagation()} onTouchStart={e=>e.stopPropagation()} onClick={() => copyText(displayCode)}>{displayCode}</div>

                    {/* --- BÁT --- */}
                    <img 
                        src={imgChen} 
                        className={`obj-bat ${isShaking ? "shaking" : ""} ${isBowlOpen ? "open" : ""} ${isDropping ? "dropping" : ""}`} 
                        draggable="false" 
                        onContextMenu={e => e.preventDefault()} 
                        alt="" 
                        style={{ 
                            transform: (!isBowlOpen && !isShaking && !isDropping) ? `translate(${bowlOffset.x}px, ${bowlOffset.y}px)` : undefined,
                            cursor: (isNan && rawSecond <= 15 && !isBowlOpen) ? 'grab' : 'default',
                            zIndex: 4000, 
                            pointerEvents: (isNan && rawSecond <= 15 && !isBowlOpen) ? 'auto' : 'none',
                            touchAction: 'none', 
                            transition: isUserDraggingBowl ? 'none' : 'transform 0.5s ease-out, opacity 0.5s ease-out'
                        }}
                        onMouseDown={startSqueeze}
                        onTouchStart={startSqueeze}
                    />
                    
                    {rawSecond <= 15 && <div className="obj-timer-wait" style={{ pointerEvents: 'none' }}>{second}</div>}
                    {!isBowlOpen && rawSecond > 15 && <div className="obj-timer gold-bar-text" style={{ pointerEvents: 'none' }}>{second}</div>}

                    {((total.length > 0 && total[0].result) || isShuffle) && (
                        <>
                            <div 
                                className={`obj-dice-group ${isShuffle ? "shuffling" : ""} ${isBowlOpen ? "show-dice" : ""}`} 
                                style={{ 
                                    opacity: (isShuffle || (total.length > 0 && total[0].result && (isBowlOpen || (isNan && rawSecond <= 15)))) ? 1 : 0, 
                                    
                                    zIndex: isShuffle ? 4500 : 5 
                                }}
                            >
                                {(total.length > 0 && total[0].result ? total[0].result : "1 2 3")
                                    .split(" ").map((d, i) => (
                                    <img key={i} src={diceMap[d]} className="dice-item" draggable="false" alt="" />
                                ))}
                            </div>
                            
                            {total.length > 0 && total[0].result && isBowlOpen && !isDropping && !isShaking && !isShuffle && (
                                <div className="obj-result-total-group" onClick={(e) => { e.stopPropagation(); setShowDetail(true); }}>
                                    <div className="obj-total-text-only gold-bar-text">{sumDice}</div>
                                </div>
                            )}
                        </>
                    )}
                    <img src={txtTai} className={`obj-img-tai btn-effect ${choose.includes('3') ? 'active' : ''} ${winSide === 'TAI' ? 'winner-blink' : ''}`} onClick={() => onChoose("3")} draggable="false" alt="TAI" />
                    <div className="obj-stat-tai-user"><i className="ti-user"></i> {bet?.total_users_tai || 0}</div>
                    <div className="money-wrapper tai-wrapper">
                        <div className="obj-stat-tai-money gold-bar-text">{formatMoney(bet?.total_money_tai || 0)}</div>
                    </div>
                    
                    {myBetTai > 0 && <div className="obj-mybet-tai">{formatMoney(myBetTai)}</div>}
                    
                    {choose.includes('3') ? <div className="obj-user-bet-tai gold-bar-text">{newMoney || "0"}</div> : <img src={btnCuocSmall} className="obj-btn-cuoc-tai btn-effect" onClick={() => onChoose("3")} alt="Cuoc" />}

                    <img src={txtXiu} className={`obj-img-xiu btn-effect ${choose.includes('4') ? 'active' : ''} ${winSide === 'XIU' ? 'winner-blink' : ''}`} onClick={() => onChoose("4")} draggable="false" alt="XIU" />
                    <div className="obj-stat-xiu-user"><i className="ti-user"></i> {bet?.total_users_xiu || 0}</div>
                    <div className="money-wrapper xiu-wrapper">
                         <div className="obj-stat-xiu-money gold-bar-text">{formatMoney(bet?.total_money_xiu || 0)}</div>
                    </div>
                    
                    {myBetXiu > 0 && <div className="obj-mybet-xiu">{formatMoney(myBetXiu)}</div>}
                    
                    {choose.includes('4') ? <div className="obj-user-bet-xiu gold-bar-text">{newMoney || "0"}</div> : <img src={btnCuocSmall} className="obj-btn-cuoc-xiu btn-effect" onClick={() => onChoose("4")} alt="Cuoc" />}

                    <div className={`bet-control-group ${choose.length > 0 ? 'active' : ''}`}>
                        <img src={btnAllIn} className="obj-btn-allin btn-effect" onMouseDown={e=>e.stopPropagation()} onTouchStart={e=>e.stopPropagation()} onClick={() => { playClick(); setNewMoney(formatMoney(Number(newMoney.replaceAll(".",""))*2)); }} alt="X2" />
                        <img src={btnDatCuoc} className="obj-btn-datcuoc btn-effect" onMouseDown={e=>e.stopPropagation()} onTouchStart={e=>e.stopPropagation()} onClick={onSubmit} alt="DatCuoc" />
                        <img src={btnHuy} className="obj-btn-huy btn-effect" onMouseDown={e=>e.stopPropagation()} onTouchStart={e=>e.stopPropagation()} onClick={handleHuy} alt="Huy" />
                        {['1000','10000','50000','100000','500000','1000000','10000000', '20000000'].map((v, i) => (
                            <img key={i} src={chipMap[v]} alt={v} className={`obj-chip chip-${v} ${activeOption === v ? 'active' : ''} btn-effect`} onMouseDown={e=>e.stopPropagation()} onTouchStart={e=>e.stopPropagation()} onClick={() => handleOptionClick(v)} draggable="false" />
                        ))}
                    </div>
                    
                    <div className="obj-roadmap" onClick={() => { playClick(); setShowSoiCau(true); }}>
                        {[...total].slice(0, 18).reverse().map((item, idx) => {
                            const sum = item.result.split(" ").reduce((a,b)=>Number(a)+Number(b),0);
                            return <img key={idx} src={sum > 10 ? dotTai : dotXiu} className="dot-mini" alt="" />
                        })}
                    </div>
                </div>
            </div>

            {showChat && (
                <div ref={chatRef} className="draggable-chat" style={{ transform: `translate(0px, 0px)` }}>
                    <div className="chat-scaler">
                        <div className="chat-drag-handle" onMouseDown={(e) => startDrag(e, 'chat')} onTouchStart={(e) => startDrag(e, 'chat')}></div>
                        <img src={bgChat} className="chat-bg-img" alt="ChatBG" draggable="false" />
                        <div className="chat-inner-content">
                            <img src={btnCloseChat} className="btn-close-chat-img btn-effect" onMouseDown={e=>e.stopPropagation()} onTouchStart={e=>e.stopPropagation()} onClick={() => setShowChat(false)} alt="Close" />
                            <div className="chat-list" ref={chatBoxRef} onMouseDown={e=>e.stopPropagation()} onTouchStart={e=>e.stopPropagation()}>
                                {messages.map((m, i) => <div key={i} className="chat-row"><b style={{color: m.username === profile?.username ? '#4ade80' : '#f1c40f'}}>{m.username}:</b> {m.content}</div>)}
                            </div>
                            <form className="chat-form" onSubmit={sendMessage} onMouseDown={e=>e.stopPropagation()} onTouchStart={e=>e.stopPropagation()}>
                                <input value={msgInput} onChange={e => setMsgInput(e.target.value)} placeholder="Nhập..." />
                                <img src={btnChatGui} className="btn-send-img btn-effect" onClick={sendMessage} alt="Gui" />
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {showGuide && (
                <div className="modal-overlay" onClick={() => setShowGuide(false)}>
                    <div className="modal-box guide-box" onClick={e => e.stopPropagation()}>
                        <img src={imgGuide} className="guide-img" alt="Huong Dan" />
                        <img src={btnCloseChat} className="btn-close-modal btn-effect" onClick={() => setShowGuide(false)} alt="Close" />
                    </div>
                </div>
            )}

            {showHistory && (
                <div className="modal-overlay" onClick={() => setShowHistory(false)}>
                    <div className="modal-box history-box" onClick={e => e.stopPropagation()}>
                        <img src={bgHistory} className="history-bg-img" alt="HistoryBG" />
                        <img src={btnCloseChat} className="btn-close-modal btn-effect" onClick={() => setShowHistory(false)} alt="Close" />
                        <div className="history-content">
                            <div className="h-title">LỊCH SỬ CƯỢC</div>
                            <div className="h-list">
                                <div className="h-row h-head"><span>Phiên</span><span>Cửa</span><span>Tiền</span><span>Hoàn</span><span>Kết quả</span></div>
                                {currentHistoryData.length > 0 ? currentHistoryData.map((item, key) => (
                                    <div key={key} className="h-row">
                                        <span>#{item.id_bet}</span>
                                        <span className={item.state === '3' ? 't-tai' : 't-xiu'}>{item.state === '3' ? "Tài" : "Xỉu"}</span>
                                        <span className="t-money">{formatMoney(item.money)}</span>
                                        <span className="t-refund">{formatMoney(item.moneytralai || 0)}</span>
                                        <span className={item.status_bet === "Win" ? "t-win" : (item.status_bet === "Lose" ? "t-lose" : "t-wait")}>
                                            {item.status_bet === "Win" ? `+${formatMoney(item.moneythang)}` : (item.status_bet === "Lose" ? "Thua" : "Đang xử lý")}
                                        </span>
                                    </div>
                                )) : <div className="no-data">Chưa có lịch sử</div>}
                            </div>
                            <div className="h-footer-pagination">
                                {currentPage > 1 && <img src={icoPageBack} className="btn-page btn-prev btn-effect" onClick={handlePrevPage} alt="Back" />}
                                <span className="page-num">{currentPage} / {totalPages || 1}</span>
                                {currentPage < totalPages && <img src={icoNext} className="btn-page btn-next btn-effect" onClick={handleNextPage} alt="Next" />}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showDetail && total.length > 0 && (
                <div className="modal-overlay" onClick={() => setShowDetail(false)}>
                    <div className="modal-box detail-box" onClick={(e) => e.stopPropagation()}>
                        {(() => {
                            const dice = total[0].result.split(" ");
                            const sum = dice.reduce((a,b)=>Number(a)+Number(b),0);
                            return (
                                <div className="detail-content">
                                    <div className="d-title">PHIÊN #{bet?.id_bet}</div>
                                    <div className="d-dice-row">
                                        <img src={diceMap[dice[0]]} alt="d1" /> <div className="d-plus">+</div> <img src={diceMap[dice[1]]} alt="d2" /> <div className="d-plus">+</div> <img src={diceMap[dice[2]]} alt="d3" /> <div className="d-equal">=</div> <div className={`d-sum ${sum > 10 ? 't-tai' : 't-xiu'}`}>{sum}</div>
                                    </div>
                                    <div className="d-result-text">{sum > 10 ? "TÀI" : "XỈU"}</div>
                                </div>
                            )
                        })()}
                    </div>
                </div>
            )}

            {showSoiCau && (
                <div className="modal-overlay" onClick={() => setShowSoiCau(false)}>
                    <div className="modal-box soicau-box" onClick={e => e.stopPropagation()}>
                        <img src={bgSoiCau} className="soicau-bg-img" alt="SoiCauBG" />
                        <img src={btnCloseChat} className="btn-close-modal btn-effect" onClick={() => setShowSoiCau(false)} alt="Close" />
                        {total.length > 0 && (
                            <div className="sc-header">
                                <span className="sc-phien">#{bet?.id_bet}</span>
                                <span className="sc-result">{(() => { const dice = total[0].result.split(" "); const sum = dice.reduce((a,b)=>Number(a)+Number(b),0); return <>{sum} - {sum > 10 ? <b className="t-tai">TÀI</b> : <b className="t-xiu">XỈU</b>}</>; })()}</span>
                            </div>
                        )}
                        <div className="sc-grid">
                            {[...Array(100)].map((_, i) => {
                                const item = total[i]; 
                                let dotImg = null; let sum = 0; let diceStr = "";
                                if (item && item.result) { 
                                    const dice = item.result.split(" "); 
                                    sum = dice.reduce((a,b)=>Number(a)+Number(b),0); 
                                    dotImg = sum > 10 ? dotTai : dotXiu; 
                                    diceStr = dice.join(" + "); 
                                }
                                return (
                                    <div key={i} className={`sc-cell ${activeBounce === i ? 'active-bounce' : ''}`} onMouseEnter={() => setHoverDot(i)} onMouseLeave={() => setHoverDot(null)} onTouchStart={() => setHoverDot(i)} onClick={() => handleCellClick(i)}>
                                        {dotImg && <img src={dotImg} className="sc-dot-img" alt="dot" />}
                                        {hoverDot === i && item && (
                                            <div className="sc-tooltip">
                                                <div>Phiên: #{item.id_bet}</div>
                                                <div>{diceStr} = {sum}</div>
                                                <div className={sum > 10 ? "t-tai" : "t-xiu"}>{sum > 10 ? "TÀI" : "XỈU"}</div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Russo+One&display=swap');
                html, body { overflow: hidden; height: 100%; width: 100%; position: fixed; overscroll-behavior: none; }
            .tx-md5-container { 
    background-image: url(${bgMain}); 
    background-size: cover; 
    background-position: center; 
    width: 100vw; 
    height: 100vh; 
    overflow: hidden; 
    position: fixed; 
    top: 0; 
    left: 0; 
    font-family: 'Roboto', sans-serif; 
    touch-action: none; 
    z-index: 999999; /* Thêm dòng này để đưa toàn bộ game lên lớp cao nhất */
}
                .win-effect-container { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 999; display: flex; align-items: center; justify-content: center; gap: 15px; animation: floatUp 2.5s ease-out forwards; pointer-events: none; }
                .win-icon { width: 7cqw; height: auto; filter: drop-shadow(0 0 10px #ff0); }
                .win-amount { font-family: 'Russo One', sans-serif; font-size: 8cqw; font-weight: 900; background: linear-gradient(to bottom, #ffffff 0%, #ffd700 50%, #ff8c00 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; filter: drop-shadow(0 2px 0px #000) drop-shadow(0 0 10px #ffd700); }
                @keyframes floatUp { 0% { opacity: 0; transform: translate(-50%, 0) scale(0.5); } 15% { opacity: 1; transform: translate(-50%, -50%) scale(1.3); } 25% { transform: translate(-50%, -50%) scale(1); } 85% { opacity: 1; transform: translate(-50%, -100%) scale(1); } 100% { opacity: 0; transform: translate(-50%, -150%) scale(0.8); } }
                .hud-back-btn { position: fixed; top: 70px; left: 20px; z-index: 200; cursor: pointer; width: 50px; height: 50px; transition: transform 0.2s; } .hud-back-btn:hover { transform: scale(1.1); } .hud-back-btn img { width: 100%; height: 100%; object-fit: contain; }
                .hud-user-info { position: fixed; bottom: 20px; left: 20px; z-index: 200; display: flex; align-items: center; gap: 10px; background: rgba(0,0,0,0.6); padding: 5px 15px 5px 5px; border-radius: 50px; border: 1px solid #ffd700; box-shadow: 0 0 10px rgba(0,0,0,0.5); }
                .hud-avatar-frame { width: 50px; height: 50px; border-radius: 50%; border: 2px solid #ffd700; overflow: hidden; background: #000; } .hud-avatar-frame img { width: 100%; height: 100%; object-fit: cover; }
                .hud-text-info { display: flex; flex-direction: column; justify-content: center; }
                .hud-username { color: #fff; font-weight: bold; font-size: 14px; text-shadow: 1px 1px 2px #000; }
                .hud-money { display: flex; align-items: center; gap: 5px; color: #ffd700; font-weight: bold; font-size: 22px; } .hud-money img { width: 16px; height: auto; }
                .draggable-board, .draggable-chat { position: absolute; z-index: 10; user-select: none; will-change: transform; }
                .draggable-board { top: 10%; left: calc(50% - 450px); width: 900px; aspect-ratio: 16/9; container-type: inline-size; }
                .board-scaler { width: 100%; height: 100%; position: relative; }
                .bg-frame-img { width: 100%; height: 100%; object-fit: contain; pointer-events: none; }
                .custom-noti-box { 
                    position: absolute; 
                    top: 23%; 
                    left: 50%; 
                    transform: translateX(-50%); 
                    width: 55%; 
                    z-index: 6000;
                    display: flex; 
                    justify-content: center; 
                    align-items: center; 
                    animation: fadeIn 0.3s ease-out; 
                    pointer-events: none; 
                }
                .noti-bg { width: 100%; filter: drop-shadow(0 0 5px rgba(0,0,0,0.5)); }
                .noti-text-content { position: absolute; width: 100%; text-align: center; font-family: 'Russo One', sans-serif; font-size: 2.8cqw; font-weight: bold; text-transform: uppercase; letter-spacing: 1px; }
                .noti-text-content.gold { background: linear-gradient(to bottom, #ffffcc 0%, #ffd700 45%, #ffae00 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; filter: drop-shadow(0 2px 2px rgba(0,0,0,0.8)); }
                .noti-text-content.red { background: linear-gradient(to bottom, #ffcccc 0%, #ff3300 45%, #cc0000 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; filter: drop-shadow(0 2px 2px rgba(0,0,0,0.8)); }
                .noti-text-content.green { background: linear-gradient(to bottom, #ccffcc 0%, #00ff00 45%, #006600 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; filter: drop-shadow(0 2px 2px rgba(0,0,0,0.8)); }
                .obj-chat-toggle { position: absolute; top: 33%; right: -20px; width: 60px; height: 60px; cursor: pointer; z-index: 50; transition: transform 0.2s; } .obj-chat-toggle img { width: 100%; height: 100%; object-fit: contain; }
                .obj-help-toggle { position: absolute; top: 15%; right: 7%; width: 60px; height: 60px; cursor: pointer; z-index: 50; transition: transform 0.2s; } .obj-help-toggle:hover { transform: scale(1.1); } .obj-help-toggle img { width: 100%; height: 100%; object-fit: contain; }
                .obj-history-toggle { position: absolute; top: 35%; right: 95%; width: 60px; height: 60px; cursor: pointer; z-index: 50; transition: transform 0.2s; } .obj-history-toggle:hover { transform: scale(1.1); } .obj-history-toggle img { width: 100%; height: 100%; object-fit: contain; }
                .obj-stat-toggle { position: absolute; bottom: 74%; right: 87%; width: 60px; height: 60px; cursor: pointer; z-index: 50; transition: transform 0.2s; } .obj-stat-toggle:hover { transform: scale(1.1); } .obj-stat-toggle img { width: 100%; height: 100%; object-fit: contain; }
                .obj-nan-toggle { position: absolute; bottom: 22%; left: 94%; width: 60px; height: 60px; cursor: pointer; z-index: 50; transition: transform 0.2s; } .obj-nan-toggle:hover { transform: scale(1.1); } .obj-nan-toggle img { width: 100%; height: 100%; object-fit: contain; }
                .draggable-chat { position: absolute; top: 17%; right: 70px; left: auto; width: 360px; height: 520px; z-index: 20; pointer-events: none; }
                .chat-scaler { width: 100%; height: 100%; position: relative; transform-origin: top left; pointer-events: none; }
                .chat-bg-img, .chat-inner-content, .chat-drag-handle, .btn-close-chat-img { pointer-events: auto; }
                .chat-drag-handle { position: absolute; top: 0; left: 0; width: 100%; height: 50px; cursor: grab; z-index: 5; } .chat-drag-handle:active { cursor: grabbing; }
                .chat-inner-content { position: absolute; top: 13%; left: 5%; width: 90%; height: 77%; display: flex; flex-direction: column; z-index: 6; }
                .btn-close-chat-img {
                    position: absolute;
                    top: -63px;
                    right: -20px;
                    width: 60px;
                    height: 35px;
                    cursor: pointer;
                    z-index: 30;
                    transition: transform 0.2s;
                } .btn-close-chat-img:hover { transform: scale(1.1); }
                .chat-list { flex: 1; overflow-y: auto; padding: 5px; color: #fff; font-size: 15px; text-shadow: 1px 1px 1px #000; scrollbar-width: none; margin-bottom: 5px; } .chat-list::-webkit-scrollbar { display: none; }
                .chat-row { margin-bottom: 5px; text-align: left; }
                .chat-form { position: absolute; bottom: -37px; left: 0; width: 100%; height: 40px; display: flex; align-items: center; }
                .chat-form input { flex: 1; background: rgba(0,0,0,0.6); border: 1px solid #bda873; color: #fff; padding: 0 10px; height: 100%; font-size: 14px; border-radius: 15px; outline: none; margin-right: 5px; }
                .btn-send-img { height: 40px; cursor: pointer; transition: transform 0.1s; } .btn-send-img:active { transform: scale(0.9); }
                .obj-phien { position: absolute; top: 17%; left: 52%; transform: translateX(-50%); color: #fff; font-weight: 900; font-size: 3cqw; letter-spacing: 1px; }
                .obj-md5 {
                    position: absolute;
                    bottom: 3%;
                    left: 25%;
                    width: 57%;
                    text-align: center;
                    color: #f1c40f;
                    font-size: 2.4cqw;
                    font-family: monospace;
                    cursor: pointer;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                
                .obj-bat {
                    position: absolute;
                    top: 32.4%;
                    left: 37.4%;
                    width: 25%;
                    z-index: 20;
                    transform-origin: center bottom;
                    transition: transform 0.5s ease-out, opacity 0.5s ease-out;
                }
                .obj-bat.open { transform: translateY(-200%) rotate(-15deg) scale(1.1) !important; opacity: 0 !important; }
                .obj-bat.shaking { animation: shake 0.1s infinite; }
                .obj-bat.dropping { animation: bounceInDown 0.6s ease-out forwards; } 
                
                .obj-timer {
                    position: absolute;
                    top: 48%;
                    left: 50.2%;
                    transform: translateX(-50%);
                    font-size: 8cqw;
                    z-index: 5000 !important;
                    pointer-events: none;
                }
                .obj-timer-wait { position: absolute; top: 25%; left: 50%; transform: translateX(-50%); font-size: 4cqw; color: #0f0; font-weight: bold; text-shadow: 0 0 5px #000; z-index: 5000 !important; pointer-events: none; }
                .gold-bar-text { font-family: 'Russo One', sans-serif; font-weight: 900; background: linear-gradient(to bottom, #ffffcc 0%, #ffd700 45%, #ffae00 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; filter: drop-shadow(0 2px 0px #b86e00); z-index: 5000 !important; }
                
                .winner-blink { animation: blink-animation 0.5s infinite alternate; filter: brightness(1.5) drop-shadow(0 0 10px gold); z-index: 100 !important; }
                @keyframes blink-animation { from { transform: scale(1); filter: brightness(1); } to { transform: scale(1.1); filter: brightness(1.5); } }
                .obj-dice-group {
                    position: absolute;
                    top: 52%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    z-index: 5;
                    width: 19cqw;
                    height: 19cqw;
                    pointer-events: none;
                }

                .dice-item { 
                    width: 9cqw;
                    height: 11cqw; 
                    position: absolute; 
                    filter: drop-shadow(0 4px 8px rgba(0,0,0,0.6));
                }

                .dice-item:nth-child(1) { 
                    top: 0; 
                    left: 50%; 
                    transform: translateX(-50%); 
                    z-index: 2; 
                } 

                .dice-item:nth-child(2) { 
                    top: auto;
                    bottom: 0; 
                    left: 0; 
                    transform: none;
                    z-index: 1;
                } 

                .dice-item:nth-child(3) { 
                    top: auto;
                    bottom: 0; 
                    right: 0; 
                    left: auto;
                    transform: none;
                    z-index: 1;
                }
                .obj-dice-group.show-dice { animation: popIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275); }

                .obj-result-total-group { position: absolute; top: 65%; left: 50%; transform: translateX(-50%); z-index: 40; cursor: pointer; animation: popIn 0.5s ease-out; }
                .obj-total-text-only { font-size: 6cqw; filter: drop-shadow(0 0 10px rgba(0,0,0,0.8)); }
                .obj-img-tai { position: absolute; top: 29%; left: 13%; width: 14%; cursor: pointer; transition: 0.2s; } .obj-img-tai.active { transform: scale(1.1); }
                .obj-stat-tai-user { position: absolute; top: 29.9%; left: 34.5%; color: #fff; font-size: 1.8cqw; font-weight: bold; }
                .money-wrapper {
                    position: absolute;
                    width: 22%;
                    height: 15%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 9000;
                    flex-direction: column;
                }
                .tai-wrapper { top: 48%; left: 11%; } .xiu-wrapper { top: 48%; right: 11%; }
                .obj-stat-tai-money, .obj-stat-xiu-money { 
                    width: auto; 
                    min-width: 100%; 
                    text-align: center; 
                    font-size: 4.2cqw; 
                    position: relative; 
                    z-index: 10; 
                    line-height: 1.2;
                    white-space: nowrap;
                }
                
                .obj-mybet-tai { position: absolute; top: 74%; left: 10%; width: 23%; text-align: center; font-size: 2cqw; color: #fff; font-weight: 600; z-index: 90; text-shadow: 1px 1px 2px #000; animation: none !important; }
                
                .obj-mybet-xiu {
                    position: absolute;
                    top: 74%;
                    right: 10%;
                    width: 23%;
                    text-align: center;
                    font-size: 2cqw;
                    color: #fff;
                    font-weight: 600;
                    z-index: 90;
                    text-shadow: 1px 1px 2px #000;
                    animation: none !important;
                }
                
                .obj-btn-cuoc-tai, .obj-user-bet-tai { position: absolute; top: 61%; left: 13%; width: 19%; height: 13%; cursor: pointer; display: flex; justify-content: center; align-items: center; font-size: 2.2cqw; }
                .obj-img-xiu { position: absolute; top: 29%; right: 13%; width: 14%; cursor: pointer; transition: 0.2s; } .obj-img-xiu.active { transform: scale(1.1); }
                .obj-stat-xiu-user {
                    position: absolute;
                    top: 29.9%;
                    right: 34%;
                    color: #fff;
                    font-size: 1.9cqw;
                    font-weight: bold;
                }
                .obj-btn-cuoc-xiu, .obj-user-bet-xiu { position: absolute; top: 61%; right: 12.8%; width: 19%; height: 13%; cursor: pointer; display: flex; justify-content: center; align-items: center; font-size: 2.2cqw; }
                .bet-control-group { position: absolute; width: 100%; height: 100%; top: 0; left: 0; pointer-events: none !important; opacity: 0; transform: translateY(-40px); transition: all 0.5s cubic-bezier(0.19, 1, 0.22, 1); z-index: 10; }
                .bet-control-group.active { opacity: 1; transform: translateY(0); }
                .bet-control-group > img { pointer-events: none; transition: transform 0.2s; } 
                .bet-control-group.active > img { pointer-events: auto !important; cursor: pointer; }
                .obj-btn-allin { position: absolute; bottom: -27%; left: 14.1%; width: 25%; }
                .obj-btn-datcuoc { position: absolute; bottom: -27%; left: 35%; width: 30%; }
                .obj-btn-huy { position: absolute; bottom: -27%; right: 14.1%; width: 25%; }
                .obj-btn-allin:active, .obj-btn-datcuoc:active, .obj-btn-huy:active { transform: scale(0.95); filter: brightness(0.8); }
                .obj-chip { position: absolute; bottom: -12%; width: 9%; height: auto; border-radius: 1%; transition: transform 0.2s; }
                .chip-1000 { left: 10%; } .chip-10000 { left: 20%; } .chip-50000 { left: 30%; } .chip-100000 { left: 40%; }
                .chip-500000 { left: 50%; } .chip-1000000 { left: 60%; } .chip-10000000 { left: 70%; } .chip-20000000 { left: 80%; }
                .obj-chip.active { filter: drop-shadow(0 0 5px #fff); }
                
                .obj-roadmap {
                    position: absolute;
                    bottom: 11.4%;
                    left: 30.4%;
                    width: 39%;
                    height: 29px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 2.3%;
                    cursor: pointer;
                }
                .dot-mini { width: 2.1cqw; height: 2.1cqw; }

                .modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999; display: flex; justify-content: center; align-items: center; animation: fadeIn 0.3s; background: rgba(0,0,0,0.5); }
                .modal-box { position: relative; animation: zoomIn 0.3s; }
                .btn-close-modal {
                    position: absolute;
                    top: -1px;
                    right: -3px;
                    width: 70px;
                    height: 40px;
                    cursor: pointer;
                    filter: drop-shadow(0 0 5px #000);
                    transition: transform 0.2s;
                    z-index: 10;
                }
                .header {
    align-items: center;
    background: #ffffff00;
    color: #fff;
    display: flex;
    justify-content: space-between;
    padding: .15rem .32rem;
}
                /* --- HIỆU ỨNG XÚC XẮC BAY (SHUFFLE) --- */
                .obj-dice-group.shuffling {
                    animation: flyAndSpin 1.5s cubic-bezier(0.25, 1, 0.5, 1) forwards !important;
                }

                @keyframes flyAndSpin {
                    0% {
                        /* Bắt đầu: Dưới đáy màn hình */
                        transform: translate(-50%, 150%) scale(0.5) rotate(0deg);
                        opacity: 0;
                    }
                    20% {
                        /* Bay vút lên cao */
                        transform: translate(-50%, -180%) scale(1.4) rotate(360deg);
                        opacity: 1;
                    }
                    50% {
                        /* Lộn nhào trên không trung */
                        transform: translate(-50%, -150%) scale(1.4) rotate(720deg);
                    }
                    80% {
                        /* Chuẩn bị rơi (vẫn còn hơi cao hơn đĩa 1 chút) */
                        transform: translate(-50%, -80%) scale(1.1) rotate(1080deg);
                    }
                    100% {
                        /* RƠI BỊCH XUỐNG ĐĨA (Vị trí chuẩn giữa màn hình) */
                        transform: translate(-50%, -50%) scale(1) rotate(1440deg);
                        opacity: 1;
                    }
                }
                /* Thêm hiệu ứng xoay riêng cho từng viên để nhìn loạn hơn (Tùy chọn) */
                .obj-dice-group.shuffling .dice-item:nth-child(1) { animation: spinItem 1.5s ease-in-out infinite; }
                .obj-dice-group.shuffling .dice-item:nth-child(2) { animation: spinItem 1.5s ease-in-out infinite reverse; }
                .obj-dice-group.shuffling .dice-item:nth-child(3) { animation: spinItem 1.5s ease-in-out infinite 0.2s; }

                @keyframes spinItem {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                .btn-close-modal:hover { transform: scale(1.1); }
                .guide-box { width: 60%; max-width: 800px; } .guide-img { width: 100%; height: auto; border-radius: 10px; }
                .history-box { width: 600px; height: 400px; display: flex; justify-content: center; align-items: center; }
                .history-bg-img { width: 100%; height: 100%; position: absolute; top: 0; left: 0; border-radius: 15px; }
                .history-content { position: relative; z-index: 2; width: 90%; height: 80%; color: #fff; display: flex; flex-direction: column; }
                .h-title { text-align: center; font-size: 24px; font-weight: bold; color: #ffd700; text-transform: uppercase; text-shadow: 0 2px 0 #000; margin-top: -32px; margin-bottom: 10px; }
                .h-list { flex: 1; overflow-y: auto; font-size: 14px; scrollbar-width: none; } .h-list::-webkit-scrollbar { display: none; }
                
                .h-row { 
                    display: flex; 
                    align-items: center; 
                    padding: 10px 0; 
                    border-bottom: 1px solid rgba(255,255,255,0.1); 
                    width: 100%;
                }
                .h-row span { display: block; flex-shrink: 0; }
                .h-row span:nth-child(1) { width: 20%; text-align: left; padding-left: 10px; }
                .h-row span:nth-child(2) { width: 15%; text-align: center; }
                .h-row span:nth-child(3) { width: 25%; text-align: center; }
                .h-row span:nth-child(4) { width: 15%; text-align: center; }
                .h-row span:nth-child(5) { width: 25%; text-align: right; padding-right: 10px; }

                .h-head { font-weight: bold; color: #aaa; border-bottom: 1px solid #ffd700; }
                .t-tai { color: #fff; font-weight: bold; } .t-xiu { color: #fff; font-weight: bold; } .t-money { color: #ffd700; } .t-win { color: #0f0; } .t-lose { color: #f00; } .t-wait { color: #aaa; font-style: italic; }
                .no-data { text-align: center; margin-top: 50px; color: #aaa; }
                .h-footer-pagination { display: flex; justify-content: center; align-items: center; margin-top: 10px; gap: 15px; }
                .btn-page { width: 20px; height: 20px; cursor: pointer; transition: transform 0.2s; } .btn-page:hover { transform: scale(1.1); filter: brightness(1.2); }
                .page-num { font-size: 14px; font-weight: bold; color: #ffd700; }
                .soicau-box { width: 800px; height: 500px; display: flex; flex-direction: column; justify-content: center; align-items: center; }
                .soicau-bg-img { width: 100%; height: 100%; position: absolute; border-radius: 15px; }
                .sc-header { position: absolute; top: 15px; left: 0; width: 100%; text-align: center; font-size: 24px; font-weight: bold; color: #fff; z-index: 2; text-shadow: 1px 1px 2px #000; }
                .sc-phien { margin-right: 15px; color: #0ff; }
                .sc-grid { position: relative; z-index: 2; width: 88%; height: 20%; display: grid; grid-template-columns: repeat(20, 1fr); grid-template-rows: repeat(5, 1fr); gap: 1px; margin-top: -90px; }
                .sc-cell { display: flex; justify-content: center; align-items: center; position: relative; cursor: pointer; }
                .sc-dot-img { width: 70%; height: 70%; object-fit: contain; filter: drop-shadow(0 1px 2px #000); }
                .sc-tooltip { position: absolute; bottom: 120%; left: 50%; transform: translateX(-50%); background: rgba(0, 0, 0, 0.9); padding: 5px 10px; border-radius: 5px; border: 1px solid #ffd700; color: #fff; font-size: 12px; white-space: nowrap; z-index: 100; pointer-events: none; text-align: center; box-shadow: 0 0 10px #000; }
                .detail-box { width: 600px; height: 350px; display: flex; justify-content: center; align-items: center; }
                .detail-bg-img { width: 100%; height: 100%; position: absolute; top: 0; left: 0; border-radius: 15px; box-shadow: 0 0 20px #ffd700; }
                .detail-content { position: relative; z-index: 2; width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #fff; }
                .d-title { font-size: 24px; font-weight: bold; color: #ffd700; text-transform: uppercase; margin-top: -40px; margin-bottom: 40px; }
                .d-dice-row { display: flex; align-items: center; gap: 15px; margin-bottom: 20px; }
                .d-dice-row img { width: 60px; height: 60px; filter: drop-shadow(0 2px 5px #000); }
                .d-plus, .d-equal { font-size: 40px; font-weight: bold; color: #ffd700; }
                .d-sum { font-size: 50px; font-weight: bold; color: #fff; margin-left: 10px; }
                .d-result-text { font-size: 40px; font-weight: bold; text-shadow: 0 2px 5px #000; color: #00ff00; }

                @keyframes bounce { 0%, 100% { transform: translateY(0); } 30% { transform: translateY(-10px); } 50% { transform: translateY(0); } 70% { transform: translateY(-5px); } }
                .sc-cell.active-bounce .sc-dot-img { animation: bounce 0.5s ease; }

                /* 🔥🔥 2. CSS CHỐNG CLICK ẢO & HIỆU ỨNG THẬT 🔥🔥 */
                * {
                    -webkit-tap-highlight-color: transparent !important;
                    -webkit-touch-callout: none;
                    user-select: none;
                }
                .btn-effect {
                    cursor: pointer;
                    transition: transform 0.05s ease-out; /* Phản hồi cực nhanh */
                }
                .btn-effect:hover {
                    filter: brightness(1.05);
                }
               .btn-effect:active {
    transform: scale(0.98); 
    filter: contrast(1.2) brightness(0.8);
}
                /* Chip tiền: Chỉ sáng lên, không nhảy */
                .obj-chip.active {
                    filter: brightness(1.2) contrast(1.1) !important;
                    transform: scale(1.05); 
                    z-index: 100;
                }

                @media screen and (max-width: 900px) and (orientation: portrait) {
                    .tx-md5-container { width: 100vh; height: 100vw; transform: rotate(90deg); transform-origin: bottom left; position: absolute; top: -100vw; left: 0; }
                    .pc-header { display: none; }
                    .hud-back-btn { top: 15px; left: 15px; width: 40px; height: 40px; transform: none; }
                    .hud-user-info { bottom: 15px; left: 15px; transform: none; padding: 5px; transform: scale(0.85); transform-origin: bottom left; }
                    .win-effect-container { top: 50%; left: 50%; transform: translate(-50%, -50%); }
                    .draggable-board { top: 42%; left: 40%; width: 900px; margin: 0; }
                    .board-scaler { transform: translate(-50%, -50%) scale(0.46); transform-origin: center center; }
                    .draggable-chat { top: 42%; left: 40%; right: auto; width: 360px; height: 520px; margin: 0; }
                    .chat-scaler { transform: translate(150px, -45%) scale(0.6); transform-origin: center center; }
                    .modal-box { transform: scale(0.7) !important; width: 800px; height: 500px; animation: zoomInMobile 0.3s forwards; }
                    @keyframes zoomInMobile { from { transform: scale(0.5); } to { transform: scale(0.7); } }
                    .history-box, .soicau-box, .detail-box { width: 800px; height: 500px; }
                    .h-list { font-size: 16px; } 
                    .h-title { font-size: 28px; margin-top: -36px; }
                    .sc-grid { margin-top: -95px; height: 20%; }
                    .d-title { margin-top: -20px; font-size: 24px; }
                    .d-dice-row img { width: 50px; height: 50px; } .d-plus, .d-equal { font-size: 35px; } .d-sum { font-size: 40px; }
                    .obj-mybet-tai, .obj-mybet-xiu { font-size: 2.2cqw; }
                    .obj-nan-toggle { bottom: 22%; left: 94%; width: 50px; height: 50px; } /* Mobile */
                }
                @keyframes shake { 0% { transform: translate(0,0) rotate(0deg); } 25% { transform: translate(3px, 3px) rotate(3deg); } 50% { transform: translate(-3px, -3px) rotate(-3deg); } 100% { transform: translate(0,0) rotate(0deg); } }
                @keyframes bounceInDown { 0% { opacity: 0; transform: translateY(-300%); } 60% { opacity: 1; transform: translateY(25px); } 75% { transform: translateY(-10px); } 90% { transform: translateY(5px); } 100% { transform: translateY(0); opacity: 1; } }
                @keyframes popIn { 0% { opacity: 0; transform: translate(-50%, -50%) scale(0.3); } 100% { opacity: 1; transform: translate(-50%, -50%) scale(1); } }
                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes zoomIn { from { transform: scale(0.8); } to { transform: scale(1); } }
            `}</style>
        </div>
    );
}
export default TXMD560s;